import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { classNames, Flex } from "@opensea/ui-kit";
import { CollectionMetadataChip } from "./CollectionMetadataChip";
import { CollectionMetadataChipsFragment } from "./CollectionMetadataChips.fragment";
export function CollectionMetadataChips(t0) {
  const $ = _c(28);
  let className;
  let collectionKey;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      collection: collectionKey,
      chips: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = collectionKey;
    $[3] = rest;
    $[4] = t1;
  } else {
    className = $[1];
    collectionKey = $[2];
    rest = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = t1 === undefined ? ["owner", "chain", "item_count", "created_at", "category", "drop_status"] : t1;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const chips = t2;
  let t3;
  if ($[7] !== collectionKey) {
    t3 = readFragment(CollectionMetadataChipsFragment, collectionKey);
    $[7] = collectionKey;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const collection = t3;
  const isSafeListed = collection.isVerified || collection.isApproved;
  let T0;
  let t4;
  let t5;
  if ($[9] !== chips || $[10] !== className || $[11] !== collection || $[12] !== isSafeListed || $[13] !== rest) {
    let t6;
    if ($[17] !== isSafeListed) {
      t6 = chip => {
        if (!isSafeListed && chip === "owner") {
          return false;
        }
        return true;
      };
      $[17] = isSafeListed;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    const filteredChips = chips.filter(t6);
    T0 = Flex;
    if ($[19] !== className) {
      t4 = classNames("scrollbar-hidden w-full flex-nowrap gap-2 overflow-auto", className);
      $[19] = className;
      $[20] = t4;
    } else {
      t4 = $[20];
    }
    let t7;
    if ($[21] !== collection || $[22] !== rest) {
      t7 = chip_0 => <CollectionMetadataChip chip={chip_0} collection={collection} key={chip_0} {...rest} />;
      $[21] = collection;
      $[22] = rest;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    t5 = filteredChips.map(t7);
    $[9] = chips;
    $[10] = className;
    $[11] = collection;
    $[12] = isSafeListed;
    $[13] = rest;
    $[14] = T0;
    $[15] = t4;
    $[16] = t5;
  } else {
    T0 = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  let t6;
  if ($[24] !== T0 || $[25] !== t4 || $[26] !== t5) {
    t6 = <T0 className={t4}>{t5}</T0>;
    $[24] = T0;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  return t6;
}